//cookie code
function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    var expires = "expires="+d.toUTCString();
    document.cookie = cname + "=" + cvalue + "; " + expires;
}      
function _fnaccept() {
    setCookie('isvisited','yes',30);
    setCookie('isvisitedpopup','yes',30);
    $("#shopify-section-cookies").fadeOut();
  $("#shopify-section-popup-newsletter").fadeOut();
  
}
      
function getCookie(cname) {
var name = cname + "=";
var ca = document.cookie.split(';');
for(var i=0; i<ca.length; i++) {
   var c = ca[i];
   while (c.charAt(0)==' ') c = c.substring(1);
   if (c.indexOf(name) != -1) return c.substring(name.length,c.length);
}
  return "";
}

 $(function(){
      var isvisited = getCookie("isvisited");
      var isvisitedpopup = getCookie("isvisitedpopup");
      
      if (isvisited == null || isvisited=='')  {
        $(window).on('load', function() {
          $("#shopify-section-cookies").fadeIn();
          $("#shopify-section-popup-newsletter").fadeIn();        
        });
      }
   
      $(".cookie_accept").click(function() {
        setCookie('isvisited','yes', 30);
        $("#shopify-section-cookies").fadeOut();
      });

      //newsletter close
       $(".close_popup, .popup_over").click(function() {
        setCookie('isvisitedpopup','yes', 30);
       $("#shopify-section-popup-newsletter").fadeOut();        
      });    



   
   
});
//end cookie and newsletter